export default __webpack_public_path__ + "static/media/CircleMenuItem.4010fd64.less";